module.exports = __webpack_public_path__ + "static/media/ic_invest_insurance.6eef9ada.svg";